import { formatDocument, toggleLineComment, duplicateLine, selectNextOccurrence } from './formatter';

/**
 * @param {object} editor Monaco editor instance
 * @param {object} monaco Monaco namespace
 * @param {{ onSave?: () => void, onSaveAs?: () => void }} [fileActions]
 */
export function bindEditorShortcuts(editor, monaco, fileActions = {}) {
  if (!editor || !monaco) return () => {};

  const disposables = [
    editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.Slash, () => {
      toggleLineComment(editor);
    }),
    editor.addCommand(monaco.KeyMod.Shift | monaco.KeyMod.Alt | monaco.KeyCode.DownArrow, () => {
      duplicateLine(editor);
    }),
    editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyD, () => {
      selectNextOccurrence(editor);
    }),
    editor.addCommand(monaco.KeyMod.Alt | monaco.KeyMod.Shift | monaco.KeyCode.KeyF, () => {
      formatDocument(editor);
    }),
    // Override browser "Save page" — use Practice IDE local save instead.
    editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS, () => {
      fileActions.onSave?.();
    }),
    editor.addCommand(
      monaco.KeyMod.CtrlCmd | monaco.KeyMod.Shift | monaco.KeyCode.KeyS,
      () => {
        fileActions.onSaveAs?.();
      },
    ),
  ];

  return () => {
    disposables.forEach((d) => d?.dispose?.());
  };
}
